<template>
  <footer>
    <section class="footer">
      <article class="footer-link">
        <p>
          <a href="javascript:;"
             class="f-link"
             v-for="{spltSecd, nm} in splts"
             :key="spltSecd"
             @click="txtSplt_click({spltSecd, nm})">{{ nm }}</a>
        </p>
        <address>
          사업자명: (주)온앤온정보시스템 / 사업자번호: 120-81-84415 / 대표: 김종찬<br />
          (05355) 서울시 강동구 양재대로 1443 동우빌딩 7층 / 대표전화:1577-7522 / FAX:02-478-8366<br />
          COPYRIGHT(C) 2023 (주)온앤온정보시스템 ALL RIGHTS RESERVED.
        </address>
      </article>
      <div>
        <a href="http://pf.kakao.com/_xfeMJG/chat" target="_blank">
          <img src="@/assets/img/main/kakaotalk-chanel.png" alt="">
        </a>
        <a>
          <img src="@/assets/img/main/kakaotalk-qrcode.png"
               alt="" style="width: 80px;">
        </a>
      </div>
    </section>
  </footer>
</template>

<script setup>
import SpltPopup from "@/components/splt-popup.vue";

import {ref} from "vue";
import {getUtils, getStore} from "@/utils/import";
const {$popup, $cmmn} = getUtils();
const {$loading} = getStore();

const splts = ref([
  {spltSecd: '001', nm: '이용약관'},
  {spltSecd: '004', nm: '개인정보 처리방침'},
]);

const txtSplt_click = async ({spltSecd, nm}) => {
  try {
    $loading.on();

    openCmmnPopup(nm, spltSecd);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const openCmmnPopup = (header, spltSecd) => {
  const popupOpts = {
    header,
    contentStyle: {
      'width': '800px',
      'max-height': '600px',
      'overflow': 'auto'
    }
  };

  $popup.show(SpltPopup, popupOpts, {spltSecd, begnDeNdctAt: 'Y'});
}
</script>

<style scoped>

</style>
